import './league.css';
import { LeagueContent } from './league-content';
import { useGetLeague, UseLeagueResult } from '../../hooks';
import { createContext } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../../routes';
import { ClanArenaWrapper } from './clan-arena';
import { TokensProvider } from '../../context';

export const LeagueContext = createContext<UseLeagueResult | undefined>(
  undefined,
);

const LeagueWrapperProvider = () => {
  const league = useGetLeague();
  const location = useLocation();

  const isClanArena = location.pathname.endsWith(`${ROUTES.CLAN_ARENA}`);

  return (
    <LeagueContext.Provider value={{ ...league }}>
      <TokensProvider mode={isClanArena ? 'arena' : 'main'}>
        {isClanArena ? <ClanArenaWrapper /> : <LeagueContent />}
      </TokensProvider>
    </LeagueContext.Provider>
  );
};

export default LeagueWrapperProvider;
